import type { PoiCategory } from "../../lib/search/categories.ts";
import {
  featuredPoiCategories,
  matchPoiCategories,
} from "../../lib/search/categoryMatching.ts";
import type { PhotonFeature } from "./photon.ts";

const QUERY_CATEGORY_SUGGESTION_LIMIT = 2;

export type GeocoderSearchState =
  | { status: "idle" }
  | { status: "loading"; query: string }
  | { status: "error"; query: string }
  | { status: "success"; query: string; results: PhotonFeature[] };

export interface SearchSuggestionsModel {
  state: "featured" | "query";
  categories: PoiCategory[];
  geocoderResults: PhotonFeature[];
  geocoderStatus: GeocoderSearchState["status"];
  noSuggestionsForQuery: boolean;
}

export function buildSearchSuggestionsModel(
  inputValue: string,
  geocoderState: GeocoderSearchState,
): SearchSuggestionsModel {
  const query = inputValue.trim();
  if (query === "") {
    return {
      state: "featured",
      categories: featuredPoiCategories(),
      geocoderResults: [],
      geocoderStatus: "idle",
      noSuggestionsForQuery: false,
    };
  }

  const currentGeocoderState = geocoderState.status !== "idle" &&
      geocoderState.query === inputValue
    ? geocoderState
    : { status: "idle" as const };
  const categories = matchPoiCategories(query).slice(
    0,
    QUERY_CATEGORY_SUGGESTION_LIMIT,
  );
  const geocoderResults = currentGeocoderState.status === "success"
    ? currentGeocoderState.results
    : [];

  return {
    state: "query",
    categories,
    geocoderResults,
    geocoderStatus: currentGeocoderState.status,
    noSuggestionsForQuery: currentGeocoderState.status === "success" &&
      categories.length === 0 &&
      geocoderResults.length === 0,
  };
}
